import { Component, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { Settings } from 'src/app/app.settings.model';
import { Router, ActivatedRoute } from '@angular/router';
import { FindTimeService } from 'src/app/core/services/find-time.service';
import { StandbyService } from '../../standby/standby.service';
import { AuthenticateService } from 'src/app/core/services/authenticate.service';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AppSettings } from 'src/app/app.settings';
import { Arguments } from 'src/app/core/models/arguments';
import { ApiResponseCode, TreatmentType } from 'src/app/core/enums';
import { Pricelist } from 'src/app/core/interfaces/pricelist';
import { PriceListCode } from 'src/app/core/models/price-list-code';
import { PricelistCodeFilterPipe } from '../pricelist-code-filter.pipe';
import { AppData } from 'src/app/app.data';
import { AppointmentModel } from 'src/app/core/models/appointment-model';
//import { elementEventFullName } from '@angular/compiler/src/view_compiler/view_compiler';



@Component({
  selector: 'app-select-from-pricelist',
  templateUrl: './select-from-pricelist.component.html',
  styleUrls: ['./select-from-pricelist.component.scss']
})
export class SelectFromPricelistComponent implements OnInit, OnDestroy {

  form: UntypedFormGroup;
  error: string;
  settings: Settings;
  hasPermission: boolean;
  arguments: Arguments;
  priceLists: Pricelist[] = [];
  priceListCodes: PriceListCode[] = [];
  prevSelectedItems: PriceListCode[] = [];
  hasTreatmentsFromSeries = false;
  appointment:AppointmentModel = null; // will be not null when moving appointment
  

  constructor(private appSettings: AppSettings,
    public fb: UntypedFormBuilder,
    public translate: TranslateService,
    private authService: AuthenticateService,
    private standbyService: StandbyService,
    private location: Location,
    private findTimeService: FindTimeService,
    private router: Router,
    private route: ActivatedRoute,
    private appData: AppData) {
    this.settings = appSettings.settings;
    this.arguments = appData.arguments;
    this.hasPermission = authService.claims.CanEditConfidentialPatients || false;
  }

  ngOnInit() {
    
    this.appointment = this.appData.appointment;
    

    this.form = this.fb.group({
      options: ['treatment'],
      pricelist: [-1],
      search: ['']
    });

    
    this.prevSelectedItems = this.appData.priceListCodes;
    this.loadPriceLists();
    
    this.onChanges();

    this.hasTreatmentsFromSeries = this.appData.isSeriesSelected();
    if (this.hasTreatmentsFromSeries) {
      this.f.options.setValue('series');
    }
  }

  onChanges() {
    this.f.options.valueChanges.subscribe(options => {
      this.loadPriceListCodes();
    });
    this.f.pricelist.valueChanges.subscribe(x => {
      this.loadPriceListCodes();
    });
    this.f.search.valueChanges.subscribe(x => {
      console.log('pricelist changed');
      this.loadPriceListCodes(); 
    });
  }


  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  // for debug only
  get diagnostic() { return JSON.stringify(this.form.value); }

  filterCodes(text) {

  }

  loadPriceLists() {
    this.findTimeService.getPriceList(this.arguments).subscribe(
      result => {
        if (result.Code === ApiResponseCode.Success) {
          this.priceLists = result.Data as Pricelist[];
          const selectedPriceList = this.priceLists.find(x => x.Selected);
          if (selectedPriceList) {
            this.f.pricelist.setValue(selectedPriceList.ID);
          }
        } else {
          this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
        }
      },
      error => {
        this.error = error;
      }
    );
  }

  loadPriceListCodes() {
    this.arguments.Pricelist = this.f.pricelist.value;

    const treatmentType = this.f.options.value;
    if (treatmentType === 'treatment') {
      this.arguments.Type = TreatmentType.Treatment;
    } else {
      this.arguments.Type = TreatmentType.Series;
    }

    if (!this.arguments.Pricelist) {
      return;
    }
    if (!this.arguments.Type) {
      return;
    }


    this.findTimeService.getPriceListCodes(this.arguments)
      .subscribe(
        result => {
          if (result.Code === ApiResponseCode.Success) {            
            this.priceListCodes = result.Data as PriceListCode[];             
            if(this.prevSelectedItems){
              this.priceListCodes.forEach(element => {
                var item = this.prevSelectedItems.filter(x=> x.ID == element.ID && x.PriceListRefID == element.PriceListRefID)[0];
                if(item != null){
                  element.FinalPrice = item.FinalPrice;
                }
              });
            }

          } else {
            this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
          }
        },
        error => {
          this.error = error;
        }
      );

  }

  

  back() {
    this.appData.priceListCodes = this.prevSelectedItems;
    this.location.back();
  }


  hasSelectedItems() {
    const list = this.appData.priceListCodes || [];
    return list.length > 0;
  }

  onOK() {
    this.location.back();
  }

  totalSelected() {
    return (this.appData.priceListCodes || []).length;
  }

  


  ngOnDestroy(): void {
    
  }

}
